export default __webpack_public_path__ + "static/media/0xf28164a485b0b2c90639e47b0f377b4a438a16b1.536e9161.png";